// extracted by mini-css-extract-plugin
module.exports = {"dropDownMenuDivider":"dropDownMenuDivider__-rBU9","label":"label__QPcvq"};